// takes an array of objects and the name of a property of these objects
// https://domhabersack.com/array-group-by
const groupBy = (array, property) =>
    array.reduce(
        (grouped, element) => ({
            ...grouped,
            [element[property]]: [
                ...(grouped[element[property]] || []),
                element
            ]
        }),
        {}
    );

export default groupBy;
